import React, {useEffect, useState} from 'react';

// styling
import { Spacing } from '_styles';

// icon
import { MdEditNote } from "react-icons/md";

const Comment = (props) => {

    return (
        <button onClick={() =>props.setShowInput(true)} style={styles.commentButton}>
            
            {/* comment */}
            { props.comment ?
                <div style={styles.commentContainer}>
                    <p style={styles.comment}>{props.comment}</p>
                    <MdEditNote size={24} color={'#000000'} />
                </div>
            :   
            
            /* add comment button */
            <div>
                <span style={styles.text}>
                    <MdEditNote size={24} color={'#000000'} /> {props.comment ? "Edit Note" : "Add Note"}
                </span>
            </div>
            }
        
        </button>
    );
};

const styles = {
    commentButton: {
        width: '100%',
        borderRadius: 10,
        border: '1px solid #ccc',
        backgroundColor: '#f9f9f9',
        cursor: 'pointer',
        display: 'flex', justifyContent: 'center', alignItems: 'center',

        padding: Spacing.SCALE_12,
        gap: Spacing.SCALE_12,
        marginBottom: Spacing.SCALE_12,
        marginTop:Spacing.SCALE_12
    },
    text: {
        fontSize: 16,
        color: '#333',
        fontWeight: '500',
    },
    commentContainer:{
        margin:0, padding:0,
        display:'flex', justifyContent:'space-between', flex:1,
        overflow:'scroll',
    },
    comment: {
        margin: 0, padding:0, 
    }
}

export default Comment;
